import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IRefesh = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M15.3546 2.64375C13.7223 1.0125 11.4822 0 8.99437 0C4.01876 0 0 4.0275 0 9C0 13.9725 4.01876 18 8.99437 18C13.1932 18 16.6942 15.1313 17.6961 11.25H15.3546C14.4315 13.8713 11.9325 15.75 8.99437 15.75C5.26829 15.75 2.24015 12.7238 2.24015 9C2.24015 5.27625 5.26829 2.25 8.99437 2.25C10.863 2.25 12.5291 3.02625 13.7448 4.2525L10.1201 7.875H18V0L15.3546 2.64375Z" fill="#37474F"/>
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IRefesh;
